import React from 'react';
import lang from '../Lang/lang.json';

let Info = (props) => {
  let {language} = props;
  return (
    <div id="info">
      <h3>{lang.Menu.About[language]}</h3>
      <span><strong>{lang.Menu.Version[language]}</strong><p>{props.version}</p></span>
      <span><strong>{lang.Menu.Own[language]}</strong><p>XXXXXXX</p></span>
      <span><strong>{lang.Menu.Design[language]}</strong><p>Oscar Hasengruber suenholucido.com</p></span>
    </div>
  )
}

export default Info;


// WEBPACK FOOTER //
// ./src/Components/Admin/Info.js